import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getAboutData() {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/about", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching about information"
                    });
                }
            });
    },
    getActuatorInfo() {
        var msgType = "fetchSuccess";
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/actuator/info", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching actuator information"
                    });
                }
            });
        
    },
    getThemeInfo() {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/about/theme-details", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching theme information"
                    });
                }
            });
    }
}
